import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';

// Totales por rol para el hub de /team. Activos e inactivos van sumados:
// la card enseña cuánta gente hay en ese rol, no cuánta está jugando hoy.
export type RoleCounts = {
  collectors: number;
  approachers: number;
  magos: number;
};

export function useRoleCounts(): {
  data: RoleCounts | undefined;
  isLoading: boolean;
  isError: boolean;
} {
  const query = useQuery({
    queryKey: ['team', 'role-counts'],
    queryFn: (): Promise<RoleCounts> =>
      pb.send('/api/team/role-counts', { method: 'GET' }),
    staleTime: 60_000,
  });
  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
